/** DCSA / carrier track-and-trace event codes → human-readable labels. */
const DCSA_EVENT_LABELS: Record<string, string> = {
  // Transport
  ARRI: 'Arrived',
  DEPA: 'Departed',
  // Equipment
  LOAD: 'Loaded',
  DISC: 'Discharged',
  GTIN: 'Gated in',
  GTOT: 'Gated out',
  STUF: 'Stuffed',
  STRP: 'Stripped',
  PICK: 'Pick-up',
  AVPU: 'Available for pick-up',
  DROP: 'Drop-off',
  AVDO: 'Available for drop-off',
  INSP: 'Inspected',
  RSEA: 'Resealed',
  RMVD: 'Removed',
  CUSS: 'Customs selected for scan',
  CUSI: 'Customs selected for inspection',
  CUSR: 'Customs released',
  CROS: 'Crossed',
  // Shipment
  RECE: 'Received',
  DRFT: 'Drafted',
  PENA: 'Pending approval',
  PENU: 'Pending update',
  PENC: 'Pending confirmation',
  CONF: 'Confirmed',
  REJE: 'Rejected',
  APPR: 'Approved',
  ISSU: 'Issued',
  SURR: 'Surrendered',
  SUBM: 'Submitted',
  VOID: 'Void',
  REQS: 'Requested',
  CMPL: 'Completed',
  HOLD: 'On hold',
  RELS: 'Released',
  CANC: 'Cancelled',
  // Event categories (sometimes returned as type)
  TRANSPORT: 'Transport',
  EQUIPMENT: 'Equipment',
  SHIPMENT: 'Shipment',
  // SeaRates milestone codes (occasionally seen in aggregated feeds)
  CEP: 'Container empty to shipper',
  CPS: 'Container pickup at shipper',
  CGI: 'Container arrival at first POL (gate in)',
  CLL: 'Container loaded at first POL',
  VDL: 'Vessel departure from first POL',
  VAT: 'Vessel arrival at T/S port',
  CDT: 'Container discharge at T/S port',
  TSD: 'Transshipment delay',
  CLT: 'Container loaded at T/S port',
  VDT: 'Vessel departure from T/S',
  VAD: 'Vessel arrival at final POD',
  CDD: 'Container discharge at final POD',
  CGO: 'Container departure from final POD (gate out)',
  CDC: 'Container delivery to consignee',
  CER: 'Container empty return to depot',
  LTS: 'Land transshipment',
  BTS: 'Barge transshipment',
  UNK: 'Unknown',
}

function titleCaseWords(value: string): string {
  return value
    .toLowerCase()
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}

/** Convert a DCSA/carrier event code to a readable label. */
export function formatDcsaEventLabel(code: string | null | undefined): string {
  if (code == null || String(code).trim() === '') return 'Event'
  const raw = String(code).trim()
  const normalized = raw.toUpperCase()
  if (DCSA_EVENT_LABELS[normalized]) return DCSA_EVENT_LABELS[normalized]
  // Carriers like DSV may already return a full sentence as the event text.
  if (raw.length > 6 || /\s/.test(raw)) return raw
  return titleCaseWords(raw)
}

/** Format carrier timeline title that may include a location suffix, e.g. "GTOT (Durban)". */
export function formatCarrierEventTitle(title: string, eventCode?: string): string {
  const locationMatch = title.match(/^(.+?)\s*\((.+)\)$/)
  const code = eventCode ?? (locationMatch ? locationMatch[1] : title)
  const label = formatDcsaEventLabel(code)
  if (locationMatch) return `${label} (${locationMatch[2]})`
  return label
}
